"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icons = require("../Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircleButton = function CircleButton(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'check' : _ref$type;
  var icon = type === 'check' ? /*#__PURE__*/_react.default.createElement(_Icons.Approve, {
    fill: "transparent",
    stroke: "transparent"
  }) : /*#__PURE__*/_react.default.createElement(_Icons.Update, {
    fill: "transparent"
  });
  var cls = (0, _classnames.default)(className, type === 'check' ? 'bg-default-green' : 'primary', 'flex justify-center', 'rounded-full', 'w-14 h-14 text-white z-0');
  return /*#__PURE__*/_react.default.createElement("button", {
    className: cls,
    type: "button",
    onClick: onClick
  }, icon);
};

CircleButton.propTypes = {
  onClick: _propTypes.default.func,
  className: _propTypes.default.string,
  type: _propTypes.default.string
};
var _default = CircleButton;
exports.default = _default;